import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Select from 'react-select';
import getLocale from '../../i18n/getLocale';
class AirspaceResponsiblesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      email: null,
      country_id: null,
      countries_select: [],
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/paises/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({countries_select: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      email: this.state.email,
      country_id: this.state.country_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/controlador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/controlador/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.titulo}</h3>
      <Link to="/controladores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.formulario.Nome}:</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-4 form-group">
            <label>{this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.formulario.Email}:</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.formulario.Pais}:</label>
              <Select
                className="form-field-name"
                name="country_id"
                value={this.state.country_id}
                searchable={true}
                placeholder={this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.formulario.placeHolder.SelecionarPais}
                onChange={this.handleSelectChange.bind(this, 'country_id')}
                options={this.state.countries_select}
              />    
            </div>
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ResponsaveisPeloEspacoAereo.AdicionarResponsaveisPeloEspacoAereo.formulario.botaoAdicionarResponsaveisPeloEspacoAereo}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AirspaceResponsiblesAdd;



// WEBPACK FOOTER //
// ./src/Components/AirspaceResponsibles/AirspaceResponsiblesAdd.js